import { AdvancedDateFilter } from 'components/Blotters/Filter/AdvancedDateFilter';
import { FC } from 'react';

interface PriceImprovementAdvancedFiltersProps {
  startDate?: string;
  endDate?: string;
  onStartDateFilterChanged(date: Nullable<string>): void;
  onEndDateFilterChanged(date: Nullable<string>): void;
}

export const PriceImprovementAdvancedFilters: FC<PriceImprovementAdvancedFiltersProps> = ({
  startDate,
  onStartDateFilterChanged,
  endDate,
  onEndDateFilterChanged,
}) => {
  return (
    <div className="w-100 d-flex flex-row justify-content-end border-top">
      <AdvancedDateFilter
        startDate={startDate}
        onStartDateFilterChanged={onStartDateFilterChanged}
        endDate={endDate}
        onEndDateFilterChanged={onEndDateFilterChanged}
      />
    </div>
  );
};
